import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@app/@core/services/app.service';
import { environment } from '@env/environment';
import { Subject } from 'rxjs';
import { fadeIn, fadeInOut } from '../animations';
import { ChatService } from '../chatbot-rasa.service';
import { debounceTime } from 'rxjs/operators';
import { LocalService } from '@app/@core/services/local.service';
declare let require: any;

declare let $: any;

@Component({
    selector: 'app-chat-widget',
    templateUrl: './chat-widget.component.html',
    styleUrls: ['./chat-widget.component.css'],
    animations: [fadeInOut, fadeIn],
    standalone: false
})
export class ChatWidgetComponent implements OnInit {
  @ViewChild('bottom') bottom!: ElementRef;
  @Input() public theme: 'blue' | 'grey' | 'red' = 'blue';
  @Input() public botName = 'Bot';
  @Input() public botAvatar = '../../../../assets/images/WV/wv_logo_square_trans.png';
  @Input() public userAvatar = '../../../../assets/images/chat_avator.png';
  @Input() url;
  @Input() public startingMessage: any;
  @Input() public opened = false;
  spin = false;
  menuList = [];
  openFeedback = false;
  selectedmessage = '';
  selectQuestion = '';
  loggedInUserRole = '';
  public _visible = false;
  private readonly chatService: ChatService;

  constructor(chatService: ChatService, 
    private readonly router: Router, 
    private readonly appService: AppService, 
    private readonly localStorageService: LocalService) {
    this.chatService = chatService;
    let pathname = new URL(environment.ChatBot).pathname;
    this.chatService.connect(environment.ChatBot, pathname);
  }

  public get visible() {
    return this._visible;
  }

  @Input() public set visible(visible) {
    this._visible = visible;
    if (this._visible) {
      setTimeout(() => {
        this.scrollToBottom();
        this.focusMessage();
      }, 0);
    }
  }

  public focus = new Subject();
  public clearSearch = new Subject();

  public operator;

  public client;

  public messages: any[] = [];
  currentMessages: any[] = [];
  sele;
  chart: any;
  public addMessage(from, text, type: 'received' | 'sent', islike: boolean, isdislike: boolean, question) {
    this.spin = false;
    this.messages.unshift({
      from,
      text,
      type,
      date: new Date().getTime(),
      islike,
      isdislike,
      question
    });
    this.currentMessages.unshift({
      from,
      text,
      type,
      date: new Date().getTime(),
      islike,
      isdislike,
      question
    });
    this.scrollToBottom();
  }

  public scrollToBottom() {
    if (this.bottom !== undefined) {
      this.bottom.nativeElement.scrollIntoView();
    }
  }

  public focusMessage() {
    this.focus.next(true);
  }

  ngOnInit() {
    this.initialize();
  }
  initialize() {
    this.getUserRole();
    this.startingMessage = 'Hi, how can we help you?';
    this.client = {
      name: 'Guest User',
      status: 'online',
      avatar: this.userAvatar
    };

    this.operator = {
      name: this.botName,
      status: 'online',
      avatar: this.botAvatar
    };
    if (this.opened) {
      setTimeout(() => (this.visible = true), 1000);
    }
    setTimeout(() => {
      this.addMessage(this.operator, this.startingMessage, 'received', false, false, '');
    }, 1500);
    this.chatService.getMessages().subscribe((message:any) => {
      setTimeout(() => {
        this.spin = false;
        let msg: any;
        if (isValidJSONString(message.text)) {
          msg = JSON.parse(message.text);
        } else {
          msg = message.text;
          if (msg.indexOf('LIST ') === 0) {
            console.log(msg.split('LIST ')[1]);
            msg = {data: msg.split('LIST ')[1].split('|'), msg: '', response_type:'questions'}
          }
        }
        this.addMessage(this.operator, msg, 'received', false, false, this.selectQuestion);
        setTimeout(() => {
          this.scrollToBottom();
          this.focusMessage();
        }, 0);
      }, 500);
    });
  }

  private getUserRole() {
    const loggedInUserDetailsString = this.localStorageService.getItem('userDetails');
    console.log(loggedInUserDetailsString);
    if (!!loggedInUserDetailsString && !this.loggedInUserRole) {
      const loggedInUserDetails = JSON.parse(loggedInUserDetailsString);
      this.loggedInUserRole = loggedInUserDetails.role;   
    }

    return this.loggedInUserRole;
  }

  private sendSystemMessage(message: string) {
    const userRole = this.getUserRole()
    console.log("Message to bot: ${`${message} ${userRole}`}");
    this.chatService.sendMessage(`${message} ${userRole}`)
  }

  public toggleChat() {
    if (this.messages.length === 1) {
      this.sendSystemMessage('main categories');
    }
    this.visible = !this.visible;
  }

  public sendMessage({ message }) {
    this.selectQuestion = message;
    if (message.trim() === '') {
      return;
    }
    const currentMessage = this.sendMenuKey(message);
    this.addMessage(this.client, message, 'sent', false, false, this.selectQuestion);
    this.spin = true;
    const userRole = this.getUserRole()
    console.log("Message to bot: ${`${currentMessage} ${userRole}`}");
    this.chatService.sendMessage(`${currentMessage} ${userRole}`);
    setTimeout(() => {
      if (this.spin) {
        this.addMessage(this.client, `I'm sorry, but I couldn't find the information you're looking for at the moment. It's possible that the topic is not within my knowledge base, or the question may require more context. Please feel free to rephrase your question or provide additional details, and I'll do my best to assist you.`, 'received', false, false, this.selectQuestion)
      }
    }, 10000);
  }
  public searchMessage({ message }) {
    if (message.trim() === '') {
      return;
    }
    this.chatService
      .searchMenus(message)
      .pipe(debounceTime(2000))
      .subscribe((x: any) => {
        if (x) {
          this.menuList = x;
        }
      });
  }
  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === '/') {
      this.focusMessage();
    }
    if (event.key === '?' && !this._visible) {
      this.toggleChat();
    }
  }
  closeChatBot() {
    this.messages = [];
    this.chatService.disconnect();
    this.startingMessage = 'Hi, how can we help you?';
  }
  showMessage(message): any {
    if (message.text && message.text.response_type) {
      return message.text.response_type === 'table' ||
        message.text.response_type === 'text' ||
        message.text.response_type === 'questions' ||
        message.text.response_type === 'link' 
        ? true
        : false;
    }
    return false;
  }
//   showMessage(message: any): boolean {
//   return ['table', 'text', 'questions', 'link'].includes(message?.text?.response_type ?? '');
// }

  showTable(message, type): any {
    if (message.text && message.text.response_type) {
      return message.text.response_type === type ? true : false;
    }
    return false;
  }
  getHeaderName(message): any {
    if (message.text && message.text.data) {
      return message.text.data[0];
    }
    return {};
  }
  getColumnData(message): any {
    if (message.text && message.text.data) {
      return message.text.data;
    }
    return [];
  }
  raiseQuestions(message) {
    this.sendMessage({ message });
    setTimeout(() => {
      this.scrollToBottom();
      this.focusMessage();
    }, 0);
  }
  selectMessage(message) {
    this.toggleShow();
    this.toClearSearch();
    this.sendMessage({ message });
    setTimeout(() => {
      this.scrollToBottom();
      this.focusMessage();
    }, 0);
  }
  toClearSearch() {
    this.clearSearch.next(true);
  }
  downloadFile(message) {
    if (message.text.url) {
      window.open(message.text.url, '_blank');
    }
  }

  toggleShow() {
    this.menuList = [];
  }
  activeLike(message) {
    this.selectedmessage = message;
    this.currentMessages = this.currentMessages.map(x => {
      return {
        type: x.type,
        text: x.text,
        islike: x.text === message.text ? true : x.islike,
        isdislike: x.text === message.text ? false : x.isdislike,
        from: x.from,
        date: x.date,
        question: x.question
      };
    });
    this.openFeedback = true;
  }
  activeDisLike(message) {
    this.selectedmessage = message;
    this.currentMessages = this.currentMessages.map(x => {
      return {
        type: x.type,
        text: x.text,
        islike: x.text === message.text ? false : x.islike,
        isdislike: x.text === message.text ? true : x.isdislike,
        from: x.from,
        date: x.date,
        question: x.question
      };
    });
    this.openFeedback = true;
  }
  getLikeStatus(message) {
    const isLike = this.currentMessages.filter(x => x.text === message.text && x.islike);
    return isLike.length > 0 ? true : false;
  }
  getDisLikeStatus(message) {
    const isDisLike = this.currentMessages.filter(x => x.text === message.text && x.isdislike);
    return isDisLike.length > 0 ? true : false;
  }
  sendFeedback(message) {
    const feedbackQue = this.currentMessages.filter(x => x.text === message.text);
    if (feedbackQue.length > 0) {
      this.chatService.sendFeedback(feedbackQue[0]).subscribe(_x => {
        //not to be empty
      });
    }
    this.closeFeedback();
  }
  closeFeedback() {
    this.openFeedback = false;
  }
  sendMenuKey(message) {
    if (message === 'Referrals') {
      return 'orref menu';
    } else if (message === 'Expenses') {
      return 'orexp menu';
    } else {
      return message;
    }
  }
}

function isValidJSONString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
